const { TossPayments } = window; 
const clientKey = 'live_ck_LlDJaYngronJq5oBJpNVezGdRpXx'; 
const tossPayments = TossPayments(clientKey); 
export default tossPayments;
